module.exports = new __parcel__URL__("icons.448fab21.svg").toString();